import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "col-md-12 d-flex flex-wrap"
};
const _hoisted_2 = {
  class: "border list-unstyled p-3 d-flex col-md-12 border-radius-md flex-wrap picked-box",
  style: {
    "max-height": "10rem",
    "overflow-y": "auto"
  }
};
const _hoisted_3 = {
  key: 0,
  class: "col-md-12 d-flex justify-content-center align-items-center",
  style: {
    "margin": "0 auto"
  }
};
const _hoisted_4 = {
  class: "m-0"
};
const _hoisted_5 = {
  class: "m-0 ellipsis me-2 piece"
};
import AppgInput from '@/components/custom/AppgInput.vue';
import AppgSuggestionInput from '@/components/custom/AppgSuggestionInput.vue';
import { ref, toRefs, onMounted } from 'vue';
export default {
  __name: 'AppgMultiSuggestionInput',
  props: {
    modelValue: {
      type: Array,
      default: []
    },
    required: {
      type: Boolean,
      description: 'Whether input is required (adds an asterix *)'
    },
    label: {
      type: String,
      description: 'Input label (text before input)'
    },
    labelClasses: {
      type: String,
      description: 'Input label css classes',
      default: 'form-control-label'
    },
    appendIcon: {
      type: String,
      description: 'Append icon (right)'
    },
    prependIcon: {
      type: String,
      description: 'Prepend icon (left)'
    },
    placeholder: {
      type: String,
      default: '검색어를 입력하세요.'
    },
    noDataLabel: {
      type: String,
      default: '데이터가 없습니다.'
    },
    resultLabelName: {
      type: String,
      required: true
    },
    resultValueName: {
      type: String,
      required: true
    },
    dataFetchMethod: {
      type: Function,
      required: true
    }
  },
  emits: ['update:modelValue'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    onMounted(() => {
      searchArray.value = [...modelValue.value];
    });
    const {
      modelValue,
      required,
      label,
      labelClasses,
      appendIcon,
      prependIcon,
      resultLabelName,
      resultValueName
    } = toRefs(props);
    const {
      dataFetchMethod
    } = props;
    const searchResult = ref();
    const searchArray = ref([]);
    const searched = data => {
      if (searchArray.value.filter(elem => elem[resultValueName.value] == data[resultValueName.value]).length > 0) return;
      searchArray.value.push(data);
      searchResult.value = '';
      emits('update:modelValue', searchArray.value);
    };
    const flush = index => {
      searchArray.value.splice(index, 1);
      searchResult.value = '';
      emits('update:modelValue', searchArray.value);
    };
    return (_ctx, _cache) => {
      const _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
      return _openBlock(), _createBlock(AppgInput, {
        required: _unref(required),
        label: _unref(label),
        labelClasses: _unref(labelClasses),
        appendIcon: _unref(appendIcon),
        prependIcon: _unref(prependIcon)
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(AppgSuggestionInput, {
          "data-fetch-method": _unref(dataFetchMethod),
          "result-value-name": _unref(resultValueName),
          "result-label-name": _unref(resultLabelName),
          placeholder: __props.placeholder,
          "model-value": searchResult.value,
          "onUpdate:modelValue": searched,
          class: "col-md-8 mt-2",
          type: "text"
        }, null, 8, ["data-fetch-method", "result-value-name", "result-label-name", "placeholder", "model-value"]), _createElementVNode("ul", _hoisted_2, [searchArray.value.length == 0 ? (_openBlock(), _createElementBlock("li", _hoisted_3, [_createVNode(_component_font_awesome_icon, {
          icon: ['fas', 'circle-info'],
          class: "me-3"
        }), _createElementVNode("p", _hoisted_4, _toDisplayString(__props.noDataLabel), 1)])) : (_openBlock(true), _createElementBlock(_Fragment, {
          key: 1
        }, _renderList(searchArray.value, (item, index) => {
          return _openBlock(), _createElementBlock("li", {
            key: item[_unref(resultValueName)],
            class: "piece border border-radius-md ms-2 me-2 mt-1 mb-1 ps-3 pt-1 pb-1 d-flex justify-content-between align-items-center col-md-2 bg-default font-weight-bold text-white"
          }, [_createElementVNode("p", _hoisted_5, _toDisplayString(item[_unref(resultLabelName)]), 1), _createVNode(_component_font_awesome_icon, {
            icon: ['fas', 'xmark'],
            class: "me-2",
            onClick: $event => flush(index)
          }, null, 8, ["onClick"])]);
        }), 128))])])]),
        _: 1
      }, 8, ["required", "label", "labelClasses", "appendIcon", "prependIcon"]);
    };
  }
};